import req from './http.js'

// 取得票券回兌狀態excel檔案api
export const apiGetReportDownloadUrl = params => req('post', '/reservation/report/writeoff', params)

// 下載檔案
export const apiDownloadReportFile = url => req('get', url)

// 取得課程核銷狀態api
export const apiGetTicketStatus = params => req('post', '/reservation/report/projectTicketCount', params)

// 取得課程核銷狀態api
export const apiGetTicketStatusDownloadUrl = params => req('post', '/reservation/report/projectTicketCountDownload', params)

// 取得錯誤紀錄api
export const apiGetConfirmError = params => req('post', '/reservation/report/getCheckTicketNoErrorReport', params)
